import { useTranslation } from 'react-i18next';
import { Warning, Wrapper, Text } from './index.view';

const NotAutoMatchedText = () => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <Warning />
      <Text className="relative -left-1">{t('txt_unable_match_auto')}</Text>
    </Wrapper>
  );
};

export default NotAutoMatchedText;
